module.exports = __webpack_public_path__ + "static/media/rate.00986cef.svg";